export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7497.e31f0a6f.jpg";